(function () {
  function initHeaderQuickQuote() {
    var root = document.querySelector('[data-raelon-header-quote-root]');
    if (!root || root.dataset.initialized === 'true') return;

    var drawer = root.querySelector('[data-raelon-header-quote-drawer]');
    var panel = root.querySelector('[data-raelon-header-quote-panel]');
    var closeButtons = root.querySelectorAll('[data-raelon-header-quote-close]');
    var lastTrigger = null;

    if (!drawer || !panel) return;
    root.dataset.initialized = 'true';

    function triggers() {
      return document.querySelectorAll('[data-raelon-header-quote-trigger]');
    }

    function setTriggerState(isOpen) {
      triggers().forEach(function (trigger) {
        trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    }

    function openDrawer(trigger) {
      lastTrigger = trigger || null;
      var mobileMenu = document.getElementById('mobile-menu');
      if (mobileMenu && window.getComputedStyle(mobileMenu).display !== 'none') {
        var mobileClose = mobileMenu.querySelector('.header-mobile-menu-close');
        if (mobileClose) mobileClose.click();
      }

      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('raelon-header-quick-quote-open');
      setTriggerState(true);
      window.requestAnimationFrame(function () {
        panel.focus();
      });
    }

    function closeDrawer() {
      if (!drawer.classList.contains('is-open')) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('raelon-header-quick-quote-open');
      setTriggerState(false);
      if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-raelon-header-quote-trigger]');
      if (!trigger) return;
      event.preventDefault();
      openDrawer(trigger);
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', closeDrawer);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeDrawer();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeaderQuickQuote);
  } else {
    initHeaderQuickQuote();
  }

  document.addEventListener('shopify:section:load', initHeaderQuickQuote);
})();
